<!--订单.........-->
<template>
  <div>
    <div id="content">
      <div class="tabContent" style="display:block;">
        <ul class="searchUL outer">
          <li class="fr">
            <el-input placeholder="请输入快递单号" v-model="couriernumber" size="small" v-if="status==350 && false" clearable
                      style="width:150px;"
                      @keyup.enter.native="openPage">
            </el-input>
            <el-input placeholder="供应商单号或跟踪号，按enter键查询" v-model="tracknum" size="small" clearable style="width:260px;"
                      @keyup.enter.native="bindGrid" @clear="bindGrid">
            </el-input>
          </li>
          <li class="fr marginR">
            <el-date-picker size="small" style="width:210px;"  v-model="searchdatevalue" type="daterange" :value-format="'yyyy-MM-dd'" align="left" :unlink-panels="false"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </li>
          <li class="fr marginR" v-if="status=='all'||status=='400'||status=='500'">
            <el-select v-model="datetype" placeholder="请选择时间类别" size="small" style="width:115px;">
              <el-option
                :label="'按下单日期'"
                :value="'10'">
              </el-option>
              <el-option
                :label="'按发货日期'"
                :value="'20'">
              </el-option>
            </el-select>
          </li>
          <li class="fl" v-if="roletype == 'store'&&status==350&&false">
            <a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"
               @click="batchExport">
              批量打印
            </a>
          </li>
          <li class="fl" v-if="roletype == 'store'&&status==500">
            <a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"
               @click="batchExport500">
              批量打印
            </a>
          </li>
        </ul>
        <ul class="searchUL outer">
          <li class="fl">
            <el-radio-group v-model="invoicesource" size="mini" @change="bindGrid"
                            v-if="(roletype == 'store'&&status==350)">
              <el-radio-button :label="''" :key="''">全部</el-radio-button>
              <el-radio-button :label="'1'" :key="'1'">采购中</el-radio-button>
              <el-radio-button :label="'2'" :key="'2'">待打印</el-radio-button>
              <el-radio-button :label="'3'" :key="'3'">已打印</el-radio-button>
              <el-radio-button :label="'4'" :key="'4'" v-if="status==350">缺货{{cangkuquehuoNum}}</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="invoicesource" size="mini" @change="bindGrid"
                            v-if="roletype == 'machining'&&status==300">
              <el-radio-button :label="''" :key="''">全部</el-radio-button>
              <el-radio-button :label="'1'" :key="'1'">未到货</el-radio-button>
              <el-radio-button :label="'2'" :key="'2'">待加工</el-radio-button>
              <el-radio-button :label="'3'" :key="'3'">加工中</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="purchase" size="mini" @change="bindGrid" v-if="roletype == 'store'&&status==810">
              <el-radio-button :label="''" :key="''">全部</el-radio-button>
              <el-radio-button :label="'1'" :key="'1'">手工采购</el-radio-button>
              <el-radio-button :label="'2'" :key="'2'">关联销货单</el-radio-button>
              <!--<el-radio-button :label="'3'" :key="'3'">关联坏件单</el-radio-button>-->
            </el-radio-group>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 110px" v-if="showcaigoubtn" @click="showCaiGou">
              镜片类采购
            </a>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 110px" v-if="showcaigoubtn" @click="showbatchCaiGou">
              镜架类采购
            </a>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 110px" v-if="showcaigoubtn" @click="showotherCaiGou">
              其他商品采购
            </a>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 110px" v-if="showcaigoubtn" @click="showbatchDaoChu">
              批量导出
            </a>
            <!--<a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"-->
               <!--v-if="showwriteorderbtn&&((roletype == 'order'&&status==200)||(roletype=='customerservice'&&status=='all'))"-->
               <!--@click="showWriteOrderWeb">-->
              <!--填写订单-->
            <!--</a>-->
            <!--<a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"-->
               <!--v-if="showwriteorderbtn&&((roletype == 'order'&&status==200)||(roletype=='customerservice'&&status=='all'))"-->
               <!--@click="showjingjiaOrderWeb">-->
              <!--镜架下单-->
            <!--</a>-->
            <!--<a class="cgdBtn" href="javascript:void(0);"-->
               <!--v-if="showwriteorderbtn&&((roletype == 'store'&& status==660)||(roletype == 'customerservice'&& status==650))"-->
               <!--@click="showWriteReturnOrderWeb">-->
              <!--退货订单-->
            <!--</a>-->
            <!--<a class="cgdBtn" href="javascript:void(0);"-->
               <!--v-if="showwriteorderbtn&&((roletype == 'store'&& status==660)||(roletype == 'customerservice'&& status==650))"-->
               <!--@click="showWriteFrameReturnOrderWeb">-->
              <!--镜架退货订单-->
            <!--</a>-->
            <a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"
               v-if="roletype == 'machining'&&status==300"
               @click="jiagongliucheng('开始加工')">
              开始加工
            </a>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"
               v-if="roletype == 'machining'&&status==300"
               @click="jiagongliucheng('加工完成')">
              加工完成
            </a>
            <a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"
               v-if="roletype == 'machining'&&status==300"
               @click="jiagongliucheng('质检')">
              质检
            </a>
          </li>
          <li class="fr" style="width:200px;">
            <el-input placeholder="请输入订单号，enter键查询" v-model="searchdata" size="small" clearable
                      @keyup.enter.native="search" @clear="search">
              <el-button slot="append" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-input>
          </li>
          <li class="fr marginR" style="width:115px;" v-if="status=='all'">
            <el-select v-model="statuses" @change="bindGrid" filterable size="small">
              <el-option
                v-for="(item,index1) in statusobj" :label="item.text"
                :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="fr marginR" style="width:90px;" v-if="status=='810'||status=='820'"><el-button size="mini" style="padding: 4px 10px" round @click="searchGoods">查商品明细</el-button></li>
          <li class="fr marginR" v-if="status!='810'&&status!='820'" style="width:250px;">
            <AutoCustomer @clear="clearCustomerName" :size="'small'"
                          @handleSelect="afterSelExternalDept"></AutoCustomer>
          </li>
          <li class="fr marginR" v-else style="width:250px;">
            <AutoCustomer :unitgroup="3" @clear="clearPcustomer" :size="'small'" @handleSelect="afterSelPcustomer"
                          placeholder="搜索供应商，enter键结束"></AutoCustomer>
          </li>
          <li class="fr marginR" style="width:120px;"
              v-if="(status!='810'&&status!='820')&&!(roletype == 'store' ||roletype == 'buy'||roletype=='supply')">
            <el-select v-model="independentserial" @change="bindGrid('1')" filterable size="small">
              <el-option v-for="item in idd" :key="item.serialnum"
                         :label="item.dname"
                         :value="item.serialnum">
              </el-option>
            </el-select>
          </li>
          <li class="fr marginR" style="width:120px;"
              v-if="(roletype=='store'||roletype=='buy')&&(status!='400'||(status==400&&isZongBu()))">
            <el-select v-model="cangkucode" @change="bindGrid('1')" filterable size="small">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
          </li>
        </ul>
        <!--搜索end-->
        <table class="titleTable">
          <tr>
            <th class="width_200 textLeft">
              <input type="checkbox" v-model="checkedAll" @change="changestate"/>
              <label>全选</label>
            </th>
            <th class="width_400 textLeft">订单详情</th>
            <th class="width_200">金额</th>
            <th class="width_200">
              订单状态
            </th>
            <th class="width_200">处理</th>
          </tr>
        </table>
        <!--titleTable end-->
        <div class="orderTable" :style="'height:'+tableHeight(156)+'px'" id="scrollArea">
          <div class="contentTable" v-for="(item,index) in tableData">
            <div class="head">
              <p class="fl marginR-30 marginL-20">
                <input type="checkbox" v-model="checkmodel" :value="item.erpserial"/>
                <label class="color-grey">{{item.htqd||item.adddate}}</label>
              </p>
              <p class="fl marginR-30 alignleft">
                <span class="color-grey ddNum ">订单号</span>
                <span class="marginR-30 erpserial1 ">{{item.erpserial}}  <span
                  v-html="getOrderType(item)"></span></span>
                <a href="javascript:void(0);" style="display: inline-block;" @mouseenter="show1(item)"
                   @mouseleave="hide1(item)">
                  <span class="ellipsis">{{item.status==810||item.status==820? item.pcustomer:item.customername}}</span>
                  <span class="tip " v-if="!(item.status==810||item.status==820)"> <img class="iphone_icon" src="/static/img/iphone_icon.jpg"/>
                    <!--提示框-->
                <div class="sub-nav" v-show="item.isShow">
                  <div class="Tipcontent">
                    <ul>
                      <li>联系人：{{item.linkman}}</li>
                      <li>联系电话：{{item.linkmantel}}</li>
                      <li>收货地址：{{item.deliveryaddress}}</li>
                      <li>收货方式：{{item.deliverymode||""}}</li>
                    </ul>
                  </div>
                  <s><i></i></s>
                </div>
                    <!--提示框 end-->
                 </span>
                </a>
                <span style="margin-left:40px;">{{item.applybydname}}</span>
                <span style="margin-left:50px;">下单人：{{item.uname}}</span>
              </p>
              <div class="nick-name-box" v-if="item.status==350||item.status==500||item.status==810"
                   v-html="computedTime(item.htqd,item.jhjgrq,item.handleoverdate)">
              </div>
            </div>
            <!--head end-->
            <table class="mainTable">
              <tr>
                <td class="width_560" style="text-align: left" :style="picture(item)" rowspan="2">
                  <div v-for="(item1,index1) in item.jxcformdetailDOList"
                       :style="{height:'70px',paddingTop: '5px',paddingBottom: '5px',borderTop:index1>0?'1px solid #EEEEEE':'none'}">
                    <img style="width:70px;height:70px;margin-left: 10px;" :src="item1.imageUrl||''"
                         @error="imgError"/>
                    <p class="alignleft">
                      <span class="cp_title">{{item1.seedname}}</span>
                      <span>x {{item1.totalnumber||0}}</span>
                      <span :style="{marginLeft:'20px',color:item1.store<=0? '#FA8E8E':'#9FECEB'}">{{isshowstore=="0"||item1.nostock==-1?"": item1.store<=0? '库存不足' : '库存'+item1.store}}</span>
                    </p>
                    <p style="margin-top: 10px;">
                      {{changePackageSize(item1.packagesize)}}
                    </p>
                  </div>
                  <span style="padding-left: 90px" v-if="!item.jxcformdetailDOList">{{getbuyLiuYan(item.remark,item)}}</span>
                </td>
                <td class="width_200 textCenter" style="vertical-align: middle;height: 56px" rowspan="2">
                  <div style="" v-if="showZhiJianInfo&&false">
                    <p>
                      <span class="numtitle textR">抽检：</span>
                      <span class="numtitle textL">{{''}}</span>
                    </p>
                    <p>
                      <span class="numtitle textR">不合格：</span>
                      <span class="numtitle textL">{{''}}</span>
                    </p>
                    <p>
                      <span class="numtitle textR">合格比率：</span>
                      <span class="numtitle textL">{{''}}</span>
                    </p>
                    <p>
                      <span class="numtitle textR">质检人：</span>
                      <span class="numtitle textL">{{''}}</span>
                    </p>
                  </div>
                  <div style="" v-if="item.storeQueHuo">
                    <p v-for="queh in item.storeQueHuo">
                      <span class="numtitle textR">{{getPackages(queh.packagesize)}}</span>
                      <span class="numtitle textL">&nbsp;缺{{queh.creditnum}}</span>
                    </p>
                  </div>
                  <div style="" v-if="showOrderMoneyInfo&&!item.storeQueHuo">
                    <p style="">
                      <span class="numtitle textR">金额：</span>
                      <span class="numbody textL" v-if="showlookprice">￥{{( (item.htje||0)+(item.discount||0) ) | numeric(2)}}</span>
                      <span class="numbody textL" v-else>???</span>
                    </p>
                    <p style="">
                      <span class="numtitle textR">运费：</span>
                      <span class="numbody textL">￥{{(item.expressfee||0)|numeric(2)}}<span
                        v-if="roletype=='customerservice'&&item.expressfee>0&&isZongBu()"
                        style="color:Red;cursor:pointer;" title="退运费" @click="tuiYunFei(item)">(退)</span> {{item.deliverymode}}</span>
                    </p>
                    <p style="">
                      <span class="numtitle textR">折扣：</span>
                      <span class="numbody textL" v-if="showlookprice">￥{{(item.discount||0)|numeric(2)}}</span>
                      <span class="numbody textL" v-else>???</span>
                    </p>
                    <p style="" v-if="isshowpayinfo=='1'">
                      <span class="numtitle textR">实收：</span>
                      <span class="numbody textL">
                        <span v-if="showlookprice">￥{{(item.yfk||0)|numeric(2)}}</span>
                        <span v-else>???</span>
                      <span class="color-yellow">{{item.status=='700'||item.status=='660'||item.status=='655'||item.status=='650'?'待退款':item.status=='750'?'已退款': item.status!='810'&&item.status!='820'&&(isshowpayinfo=='0'||(item.yfk>0&&!item.paymethod))?"未支付":"" }} </span></span>
                    </p>
                    <p class="color-yellow">{{(item.status=='810'||item.status=='820')?"按合同结算":
                      isshowpayinfo=="0"?"":(item.paymethod||'')}}</p>
                  </div>
                </td>
                <td class="width_200 textCenter"
                    :style="{verticalAlign:roletype=='customerservice'?'middle': 'bottom',height: '56px'}"
                    :rowspan="roletype=='customerservice'?2:1">
                  <div class="color-yellow" v-if="showPcustomerInfo" v-html="getPcustomerInfo(item)"></div>
                  <div class="color-yellow" v-if="roletype!='customerservice'">
                    <div style="height: 24px;">
                    <span class="color-grey pointer HideButton" v-if="showzhuandanbtn&&isEqualIndependentSerial(item)"
                          @click="showZhuanDan(item)">{{item.buyinfo?"": item.pcustomerserial?'转单':'（修改）'}}</span>
                      <!--<span class="color-grey pointer HideButton"-->
                            <!--v-if="showzhuandanbtn&&status!=300&&isEqualIndependentSerial(item)&&isZongBu()"-->
                            <!--@click="showChaiDan(item)">{{item.buyinfo?"":'拆单'}}</span>-->
                      <!--<span class="color-grey pointer HideButton"-->
                      <!--v-if="showzhuandanbtn&&status!=300&&isEqualIndependentSerial(item)&&isZongBu()"-->
                      <!--@click="showHeBing(item)">{{item.buyinfo?"":item.pcustomerserial?'合并':''}}</span>-->
                    </div>
                  </div>
                  <div v-if="roletype=='customerservice'">
                    <div v-html="getLiuYan(item.remark,item)"
                         style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                    <div style="height: 24px;">
                      <span v-if="showliuyanbtn" class="pointer color-grey HideButton"
                            @click="showLiuYan(item)">我要留言</span></div>
                    <!--<p class="color-yellow"></p>-->
                  </div>
                </td>
                <td rowspan="2" class="width_200 textCenter btnBox">
                  <div v-if="status=='all'&&!(item.status=='500'||item.status=='400'||item.status=='750')">
                    {{getStatusName(item)}}
                  </div>
                  <div v-if="item.status=='500'||item.status=='400'" style="text-align: left;">
                    <span style="margin-left: 10px;">发货时间：{{item.handleoverdate}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">物流公司：{{item.logisticsco}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">物流单号：{{item.logisticsnum}}</span>
                  </div>
                  <div v-if="showCaiGouShouHuoInfo" style="text-align: left;">
                    <span style="margin-left: 10px;">到货日期：{{item.handleoverdate}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">入&nbsp;库&nbsp;&nbsp;人：{{item.handleoveruname}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">仓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;库：{{item.cangkuname}}</span>
                  </div>
                  <div v-if="item.status=='750'" style="text-align: left;">
                    <span style="margin-left: 10px;">办结时间：{{item.handleoverdate}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">操&nbsp;作&nbsp;&nbsp;人：{{item.handleoveruname}}</span>
                    <i style="display: block;height: 5px"></i>
                  </div>
                  <button @click="handlesaleCsagreementToVoid(item)" class="removeButton"
                          v-if="(showcancelbtn&&isEqualIndependentSerial(item))||(showtuihuikefubtn&&status=='660'&&isCangKuChargePeople(item)&&item.parentguid==undefined)">
                    取消订单
                  </button>
                  <button v-if="showcaigoubtn&&(item.needaudit!=9)&&(item.orderopinion!=null||!isBuyOrderFromSale(item))"
                          class="removeButton"
                          @click="cancelBuy(item)">
                    取消采购单
                  </button>
                  <button v-if="showxuanhuobtn&&isEqualIndependentSerial(item)">选货</button>
                  <button v-if="showlookcaigouorderbtn&&item.buyinfo" @click="lookbuyorderdetail(item,0)">查看采购单</button>
                  <button v-if="showlookcaigoubtn" @click="lookbuyorderdetail(item,1)">{{(item.jxcformdetailDOList&&item.jxcformdetailDOList.length>0&&item.jxcformdetailDOList[0].totalnumber<0)?'查看采购退货单':'查看采购单'}}</button>
                  <button
                    v-if="(showfaqicaigoubtn||showfahuotongzhicangkubtn)&&isEqualIndependentSerial(item)&&!isMachine(item)&&item.homepickup!=2"
                    @click="addMachineOrder(item)">补加工单
                  </button>
                  <button
                    v-if="showfaqicaigoubtn&&item.pcustomerserial&&isEqualIndependentSerial(item)&&!item.buyinfo"
                    @click="sbuyorder(item)">发起采购
                  </button>
                  <button v-if="showfahuotongzhicangkubtn&&isEqualIndependentSerial(item)&&isHaveStock(item)"
                          @click="handleQueRenTongZhiOrMachine(item)">{{getFaHuoTongZhiCangKuText(item)}}
                  </button>
                  <!--待配送状态显示-->
                  <button v-if="showpeisongquerenbtn&&isJingXiaoShang()"
                          @click="showErCiFaHuo(item)">
                    确认发货
                  </button>
                  <button v-if="showupdateexpressfeebtn&&isEqualApplybydserial(item)"
                          @click="showUpdateExpressFee(item)">修改运费
                  </button>
                  <button v-if="showtuihuotongzhicangkubtn&&isEqualApplybydserial(item)&&roletype == 'customerservice'"
                          @click="handleCancelTuiHuoDan(item)">驳回退货单
                  </button>
                  <button
                    v-if="showtuihuikefubtn&&((status=='660'&&item.parentguid!=undefined&&isCangKuChargePeople(item))||(status=='655'&&isEqualIndependentSerial(item))||(status=='700'&&isZongBu()))"
                    @click="showLiuYan(item,'请填写原因',(item.parentguid==undefined?'660':'655'))">
                    {{item.parentguid==undefined?'退回仓库岗':'退回订单岗'}}
                  </button>
                  <button v-if="showtuihuotongzhicangkubtn&&(roletype=='supply'||isEqualApplybydserial(item))"
                          @click="handleQueRenTongZhi(item)">同意退货
                  </button>
                  <button
                    v-if="showtuihuotongzhicaiwubtn&&((status=='660'&&(roletype=='supply'||isCangKuChargePeople(item)))||(status=='655'&&isEqualIndependentSerial(item)))"
                    @click="looktuihuo(item,1)">
                    退货确认
                  </button>
                  <button v-if="showtuihuotuikuanbtn&&isZongBu()" @click="tuikuan(item)">确认退款</button>
                  <button v-if="showtianxiefahuobtn&&isCangKuChargePeople(item)"
                          @click="showFaHuoDan(item,'填写发货单')">填写发货单
                  </button>
                  <button v-if="showtuihuidingdanbtn&&isCangKuChargePeople(item)&&(!isMachine(item)||(showlookcaigouorderbtn&&item.buyinfo))"
                          @click="showLiuYan(item,'请填写原因','200')">退回订单岗
                  </button>
                  <button v-if="showzhijiandanbtn&&false">填写质检单</button>
                  <button
                    v-if="showrukudanbtn&&isCangKuChargePeople(item)&&(!item.needaudit||item.needaudit==1||item.needaudit==-1)&&(item.orderopinion===0||!isBuyOrderFromSale(item))"
                    @click="writeRuKuDan(item,1)">填写入库单
                  </button>
                  <button
                    v-if="item.invoicesource==1&&roletype=='jiesuan'&&status=='810'"
                    @click="waitShenHe(item)">采购价审核
                  </button>
                  <el-checkbox-group v-model="item.checkedGlasses" @change="handleCheckedGlassesChange($event,item)"
                                     v-if="showquerenjiagongbtn&&isEqualIndependentSerial(item)">
                    <el-checkbox v-for="glasses in glassess" :label="glasses" :key="glasses">{{glasses}}</el-checkbox>
                  </el-checkbox-group>
                  <button v-if="showquerenjiagongbtn&&isEqualIndependentSerial(item)" @click="lookMachining(item,1)">
                    确认
                  </button>
                  <button v-if="showlookorderbtn" @click="lookDetails(item)">查看订单</button>
                  <el-input v-if="showtianxiefahuobtn&&isCangKuChargePeople(item)" placeholder="填跟踪号" size="mini"
                            style="width: 100px" v-model="item.logisticstracknum" @change="trackNo(item)">
                  </el-input>
                </td>
              </tr>
              <tr>
                <td class="width_200 textCenter" style="vertical-align: top;" v-if="roletype!='customerservice'">
                  <div>
                    <div v-html="getLiuYan(item.remark,item)"
                         style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                    <div style="height: 24px;">
                      <span v-if="showliuyanbtn" class="pointer color-grey HideButton"
                            @click="showLiuYan(item)">我要留言</span></div>
                    <!--<p class="color-yellow"></p>-->
                  </div>
                </td>
              </tr>

            </table>
          </div>
        </div>
        <!--contentTable end-->
      </div>
      <!--待确认end-->
    </div>

    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindPagination" :pagination="pagination"
                  :layout="'total , prev, pager, next, jumper'"></Pagination>
    </div>
    <BuyOrderEditSeedDetail ref="buyseeddetail" v-if="showlookcaigoubtn"></BuyOrderEditSeedDetail>
    <CstagreementEditChaiDan ref="ChaiDandetail" v-if="showzhuandanbtn"
                             @bindGrid="bindGrid('1','1')"></CstagreementEditChaiDan>
    <CstagreementEditHeBing ref="Hebingdetail" v-if="showzhuandanbtn"
                            @bindGrid="bindGrid('1','1')"></CstagreementEditHeBing>
    <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid('1','1')" @cutItemAfterHandle="cutItemAfterHandle"
                      v-if="showlookorderbtn"></CstagreementEdit>
    <BuyorderEdit ref="BuyoderEdit1" v-if="showfaqicaigoubtn" @bindGrid="bindGrid('1','1')"
                  @print="lookPrintDetails"></BuyorderEdit>
    <LiuYanEdit ref="liuyan" v-if="showliuyanbtn" @afterLiuYan="afterLiuYan"></LiuYanEdit>
    <!--<ExternaldeptSel ref="externaldeptsel" v-if="!showRenderTitle()"-->
    <!--@select="afterSelExternalDept"-->
    <!--&gt;</ExternaldeptSel>-->
    <WriteOrder ref="WriteOrder" :filterbyservedserial="true" @select="afterSelExternalLogin"></WriteOrder>
    <!--<ExternaldeptSel ref="tianxieOrder" :filterbyservedserial="true"-->
    <!--@select="afterSelExternalLogin"-->
    <!--&gt;</ExternaldeptSel>-->
    <ExternaldeptChaiDanSel ref="zhuandan" v-if="showzhuandanbtn" :unitgroup="3" @select="afterZhuanDan" :title="'选择供应商'"></ExternaldeptChaiDanSel>
    <CstagreementEdit ref="tuihuo" v-if="showtuihuotongzhicaiwubtn" @bindGrid="bindGrid('1','1')"></CstagreementEdit>
    <BuyorderDetail ref="BuyorderDetail" v-if="showlookcaigoubtn||showlookcaigouorderbtn" @bindGrid="bindGrid('1','1')"></BuyorderDetail>
    <BuyorderDetailEdit ref="BuyorderDetailEdit" v-if="showcaigoubtn"  @bindGrid="bindGrid('1','1')"></BuyorderDetailEdit>
    <BatchBuyorderDetailEdit ref="BatchBuyorderDetailEdit" v-if="showcaigoubtn"  @bindGrid="bindGrid('1','1')"></BatchBuyorderDetailEdit>
    <OtherBuyorderDetailEdit ref="OtherBuyorderDetailEdit" v-if="showcaigoubtn"  @bindGrid="bindGrid('1','1')"></OtherBuyorderDetailEdit>
    <CstagreementMachiningEdit ref="machiningedit" @bindGrid="bindGrid('1','1')"  @cutItemAfterHandle="cutItemAfterHandle"></CstagreementMachiningEdit>
    <CstagreementMachiningEdit ref="machiningeditcopy" @bindGrid="bindGrid('1','1')"></CstagreementMachiningEdit>
    <StoreEdit ref="StoreEdit" v-if="showfahuotongzhicangkubtn||showtuihuotongzhicangkubtn" @bindGrid="bindGrid('1','1')" @print="lookPrintDetails"></StoreEdit>
    <ConfirmRefundEdit ref="ConfirmRefundEdit" v-if="showtuihuotuikuanbtn" @bindGrid="bindGrid('1','1')"></ConfirmRefundEdit>
    <TwoShipmentsEdit ref="TwoShipmentsEdit" v-if="showpeisongquerenbtn" @bindGrid="bindGrid('1','1')"></TwoShipmentsEdit>
    <UpdateExpressFee ref="UpdateExpressFee" v-if="showupdateexpressfeebtn" @afterUpdateExpressFee="afterUpdateExpressFee"></UpdateExpressFee>
    <WriteReturnOrder ref="WriteReturnOrder" :filterbyservedserial="true" @bindGrid="bindGrid('1','1')"  @select="afterSelExternalLogin"></WriteReturnOrder>
    <WriteFrameReturnOrder ref="WriteFrameReturnOrder" :filterbyservedserial="true" @bindGrid="bindGrid('1','1')"  @select="afterSelExternalLogin"></WriteFrameReturnOrder>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    <FreightRefund ref="FreightRefund" @afertFreightRefund="afertFreightRefund"></FreightRefund>
    <InvoiceList ref="InvoiceList" @bindGrid="bindGrid"></InvoiceList>
    <BuyUpdateCostPrice ref="BuyUpdateCostPrice" @bindGrid="bindGrid('1','1')"></BuyUpdateCostPrice>
    <BatchBuyDaoChu ref="BatchBuyDaoChu"></BatchBuyDaoChu>
    <CstagreementEdit ref="DataContactEditCopy" @bindGrid="bindGrid" v-if="showlookorderbtn"></CstagreementEdit>
    <RapidMachining ref="RapidMachining" @bindGrid="bindGrid('1','1')"></RapidMachining>
    <AddMachinOrder ref="AddMachinOrder" @bindGrid="bindGrid"></AddMachinOrder>
    <BatchBuyorderPriceEdit ref="BatchBuyorderPriceEdit" @bindGrid="bindGrid('1','1')"></BatchBuyorderPriceEdit>
    <StoreDetailListSupplySee ref="OrderSupplySee1" :showcostprice="false"></StoreDetailListSupplySee>
  </div>
</template>

<script>
  import BuyOrderEditSeedDetail from '../buyagreement/BuyOrderEditSeedDetail'
  import CstagreementEditChaiDan from './CstagreementEditChaiDan'
  import CstagreementEditHeBing from './CstagreementEditHeBing'
  import CstagreementEdit from './CstagreementEdit';
  import InvoiceList from './InvoiceList';
  import AddMachinOrder from './AddMachinOrder'
  import CstagreementMachiningEdit from './CstagreementMachiningEdit';
  import BuyorderEdit from '../buyagreement/BuyorderEdit';
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import BatchBuyorderDetailEdit from '../buyagreement/BatchBuyorderDetailEdit';
  import OtherBuyorderDetailEdit from '../buyagreement/OtherBuyorderDetailEdit';
  import BuyorderDetailEdit from '../buyagreement/BuyorderDetailEdit';
  import StoreEdit from './StoreEdit';
  import UpdateExpressFee from './UpdateExpressFee';
  import ConfirmRefundEdit from './ConfirmRefundEdit';
  import TwoShipmentsEdit from './TwoShipmentsEdit';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  import FreightRefund from './FreightRefund';
  import {simulationLogin, checkModuleRight} from '@/api/login'
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    saveCstagreementData,
    buyoderremove,
    getGroupByCustomerAndPcustomer,
    updatejiagong,
    updateExpressFee,
    updategongying,
    comfirefahuo,
    cancelTuihuoOrder,
    updatecangku,
    trackSelect,
    glassesArrival,
  } from '@/api/set/csagreement';
  import {independentDept} from '@/api/set/dept';
  import LiuYanEdit from './LiuYanEdit'
  // import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'
  import WriteOrder from './WriteOrder'
  import WriteReturnOrder from './WriteReturnOrder'
  import RapidMachining from './RapidMachining'
  import WriteFrameReturnOrder from './WriteFrameReturnOrder'
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'
  import BatchBuyDaoChu from '@/components/testorder/buyagreement/BatchBuyDaoChu'
  import {updateaLiRefund} from '@/api/set/csagreement';
  import {computedResidualTime, getRemark} from '@/plugin/ordercommon'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveData, logremove} from '@/api/set/handlelog';
  import AutoComplete from "../../common/AutoCustomer";
  import {exportPdf} from '@/api/file'
  import BatchBuyorderPriceEdit from '../buyagreement/BatchBuyorderPriceEdit'
  import BuyUpdateCostPrice from '../buyagreement/BuyUpdateCostPrice'
  import StoreDetailListSupplySee from '../../account/StoreDetailListSupplySee'
  import {isUGO} from "../../../api/login";

  export default {
    name: 'CstagreementList',
    data() {
      return {
        canwriteorder: false,
        printItem: {},
        userInfoModel: {},
        formtype: 42,
        statuses: "",//多个状态，逗号隔开
        status: this.mystatus,
        id: '',
        fileuname: "",//加工人员
        itemtemp: {},//操作某条记录的临时变量
        isShow: false,
        activeIndex: '100',
        searchContentHeight: 50,
        glassess: ['镜架已到', '镜片已到'],
        statusobj: [{value: "150,200,300,350,400,500,650,655,660,700,750", text: "全部"},
          {value: "200", text: "待确认"}, {value: "300", text: "待加工"}, {value: "350", text: "待发货"},
          {value: "500", text: "已发货"}, {value: "700", text: "待退款"}, {value: "750", text: "退款完成"},
          {value: "400", text: "待配送"}, {value: "150", text: "待选货"}, {value: "650", text: "退货客服岗待确认"}, {
            value: "655",
            text: "退货订单岗待确认"
          }, {value: "660", text: "退货仓库岗待确认"}],
        msg: 'Welcome to Your Vue.js Ap22p',
        dialogFormVisible: false,
        searchdata: "",
        independentserial: "",
        loading: true,
        categorycode: "",
        categoryname: "",
        seedcode: "",
        seedname: "",
        iswriteorder: "",//1表示客服下单
        invoicesource: "",//发货单来源，1表示点击发起采购，2表示点击通知仓库
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        datetype: '10',//'10'表示按下单时间，'20'表示按发货时间
        searchdatevalue: [],//时间段选择
        needtuihuoinfo: "0",//是否判断此订单的是否申请过退货
        // isClickEvent: true,//选择供应商、客户清空图标按钮不触发click事件使用
        unitgroup: "",//查询条件的选择供应商或者门店使用
        pcustomer: "",//供应商，仅仅作为显示使用
        pcustomerserial: '',
        customername: '',//门店，仅仅作为显示使用
        customerserial: '',
        cangkucode: '',
        isshowstore: "0",//是否展示库存
        isshowpayinfo: "0",//是否展示支付信息
        isshowbuyinfo: "0",//是否展示采购单编号
        isshowtuihuofrombuy: "0",//采购单待收货页面是否需要根据关联的订单的退货单的数据判断是否可以点击
        showPcustomerInfo: false,//是否显示供应商信息，例如某某供应商采购中
        showzhuandanbtn: false,//显示转单按钮
        showCaiGouShouHuoInfo: false,//显示采购
        showZhiJianInfo: false,//显示质检信息
        showOrderMoneyInfo: false,//显示订单总额运费等信息
        showFaHuoInfo: false,//显示物流发货信息
        showcancelbtn: false,//显示取消按钮
        showliuyanbtn: false,//显示留言按钮
        showfahuotongzhicangkubtn: false,//显示通知仓库按钮
        fahuotongzhicangkutext: "",//发货通知仓库显示的文本，  可选值：通知仓库、通知加工
        showpeisongquerenbtn: false,//待配送页面显示  确认配送按钮
        showupdateexpressfeebtn: false,//显示修改运费按钮
        showtuihuotongzhicangkubtn: false,//显示退货通知仓库按钮，即退货客服岗确认按钮，订单明细全是备货的通知仓库，订单明细只要有不备货的就通知总部订单岗
        tuihuotongzhicangkutext: "",//即退货客服岗确认按钮的显示文本，订单明细全是备货的通知仓库，订单明细只要有不备货的就通知总部订单岗
        showtuihuotongzhicaiwubtn: false,//显示退货通知财务按钮，即退货仓库岗确认按钮
        showtuihuotuikuanbtn: false,//显示退货确认退款按钮
        showfaqicaigoubtn: false,//显示发起采购按钮
        showlookcaigoubtn: false,//显示采购模块查看采购单按钮
        showlookcaigouorderbtn: false,//显示待确认待发货查看采购单按钮
        showlookorderbtn: false,//显示查看订单按钮
        showquerenjiagongbtn: false,//显示确认加工按钮
        showxuanhuobtn: false,//显示选货按钮
        showtianxiefahuobtn: false,//显示填写发货单按钮
        showtuihuidingdanbtn: false,//显示退回订单岗按钮
        showtuihuikefubtn: false,//显示退回客服岗按钮，退货使用
        showcancelcaigoubtn: false,//显示取消采购单按钮
        showzhijiandanbtn: false,//显示填写质检单按钮
        showrukudanbtn: false,//显示填写入库单按钮
        showcaigoubtn: false,//显示 独立的 采购按钮， 采购菜单使用
        showFramecaigoubtn:false,//镜架类采购
        showwriteorderbtn: false,//显示填写订单按钮
        showlookprice: true,//显示价格
        countPageTotal: true,
        timer: null,//定时任务
        noloading: false,//是否显示 加载中 锁屏
        cangkuquehuoNum: '',//仓库缺货的数量
        purchase: '',//仓库岗待收货用
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        logistics: [],
        idd: [],
        idd1: [],
        idd2: [],
        checkmodel: [],
        checkedAll: false,
        jxcstoreData: [],
        seedcodes: [],
        couriernumber: '',//快递单号条码
        tracknum: '',//供应商号,
        erpserials: '',//根据跟踪单号获得的销售单号
        hetongserial: '',//销售单号
      }
    },
    provide() {
      return {
        afterCloseDialog: () => {
          this.afterCloseDialog()
        }
      }
    },
    props: {
      mystatus: {
        default: '200'
      },
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 buy、 store、machining、jiesuan、customerservice 、supply ， 分别对应订单、采购单、库存、加工、结算、客服、供应商利润  等菜单角色
      },
      shoudongcaigou: {//手动采购单用到  1未审核 2审核过
        default: ''
      }
    },
    methods: {
      searchGoods() {
        // if (this.pcustomerserial) {
          this.$refs.OrderSupplySee1.initData({applybydserial:this.pcustomerserial,applybydname:this.pcustomer},2, this.searchdatevalue,"");
          this.$refs.OrderSupplySee1.show();
        // } else {
        //   this.$message({
        //     message: '先选择供应商！',
        //     type: 'warning'
        //   });
        // }
      },
      //待加工、已加工、质检
      jiagongliucheng(title) {
        this.$refs.RapidMachining.show(title);
      },
     //加急、已退货图片展示
      picture(item) {
        if (item.isreturnorder&&item.isreturnorder == -1) {
          return {
            paddingRight: '0px',
            paddingLeft: '0px',
            background:  'url(/static/img/tuihuotip.png) no-repeat right center'
          }
        }else if(item.status==810&&item.needaudit) {
          // if (item.needaudit == 1) {
          //   return {paddingRight: '0px',paddingLeft: '0px',background: 'url(/static/img/waitaudit.png) no-repeat right center'}
          // }else
          if (item.needaudit == 9) {
            return {paddingRight: '0px',paddingLeft: '0px',background: 'url(/static/img/waitaudit.png) no-repeat right center'}
          }else if (item.needaudit == -1) {
            return {paddingRight: '0px',paddingLeft: '0px',background: 'url(/static/img/auditbohui.png) no-repeat right center'}
          }
        }
        // else if (item.isjiaji == 1) {
        //   return {
        //     paddingRight: '0px',
        //     paddingLeft: '0px',
        //     background: item.isjiaji == 1 ? 'url(/static/img/jiajitip.png) no-repeat right center' : ''
        //   }
        // }
      },
      //镜片、镜架是否已到
      handleCheckedGlassesChange(event, item) {
        var remark = ''
        if (event.length == 2) {
          remark = event[0] + "," + event[1]
        } else if (event.length == 1) {
          remark = event[0]
        }

        glassesArrival({
          unitguid: item.unitguid,
          erpserial: item.erpserial,
          remark: remark
        }).then(response => {

        })
      },
      //填跟踪单号
      trackNo(item) {
        var obj = {
          unitguid: item.unitguid,
          logisticstracknum: item.logisticstracknum.trim()
        }
        saveCstagreementData(obj).then(response => {
          if (response.data.code != 0) {
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          }
        })
      },
      //批量打印
      batchExport() {
        if (this.checkmodel.length == 0) {
          this.$message({
            message: "请选择需要打印的订单",
            type: "error"
          })
          return
        }
        var data = {
          checkmodel: JSON.stringify(this.checkmodel),
          businessType: 'batchExport'
        }
        exportPdf(data, "【" + this.year + "-" + this.month + "】" + "销售单")
      },
      //批量打印
      batchExport500() {
        this.$refs.BatchBuyDaoChu.show(this.roletype, this.status, this.cangkucode)
        this.$refs.BatchBuyDaoChu.init()
      },
      //根据订单号查询采购单
      trackSelect() {
        this.erpserials = ''
        trackSelect({hetongserial: this.searchdata}).then(response => {
          if (response.data.erpserials.length > 0) {
            this.erpserials = JSON.stringify(response.data.erpserials);
            this.bindGrid()
          } else {//根据跟踪单号查询不到订单
            this.tableData = []
          }
        })
      },
      //扫快递条码打开页面
      openPage() {
        this.$refs.InvoiceList.show(this.couriernumber, this.status);
      },
      // //处理日志
      // handlelog(handlelog) {
      //   saveData(handlelog).then(response => {
      //   })
      // },

      isEqualApplybydserial(item) {//总部人员只能操作总部管理的门店的订单，加工中心只能操作加工中心管理的门店的订单， 注意跟下面的操作加工中心发货的订单区别
        return this.userInfoModel.independentserial == (item.applybydserial || "")
      },
      isEqualIndependentSerial(item) {//总部人员能处理所有订单，加工中心只能操作加工中心发货的订单
        return (!this.userInfoModel.independentserial) || this.userInfoModel.independentserial == (item.independentserial || "")
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      isJingXiaoShang() {//当前是加工中心人员
        return this.userInfoModel.independentserial != ""
      },
      //是否为此仓库的负责人
      isCangKuChargePeople(item) {
        return this.userInfoModel.cangku.indexOf(item.cangkucode + ";") > -1
      },
      //采购单是否关联了销售单
      isBuyOrderFromSale(item) {
        if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          for (let i in item.jxcformdetailDOList) {
            if (item.jxcformdetailDOList[i].hetongserial) {
              return true
            }
          }
        }
        return false
      },
      // //显示 供应商、客户多少个
      // showRenderTitle() {
      //   return this.status != '500' && this.status != '750' && this.status != '820' && this.status != 'all'
      // },
      computedTime: function (game, endTime, overtime) {
        return computedResidualTime(game, endTime, overtime);
      },
      changePackageSize(PackagesizeList) {
        if(!PackagesizeList) return '';
        var pack = PackagesizeList.split(';')
        var packString = '';
        for (var i = 0; i < pack.length; i++) {
          if (pack[i] && pack[i] != ',') {
            if (pack[i].substr(0, 1) == ',') {
              pack[i] = pack[i].substr(1);
            }
            //console.log(pack[i])
            try {
              var ps = JSON.parse(pack[i]);
              var rl = '';
              if (ps.Y) {
                if (ps.type)
                  rl = ps.type + ',';
                packString += "（" + rl + 'S:' + ps.Y + ',C:' + ps.X + "）";
              } else {
                if (ps.M || ps.C) {
                  packString += "（" + ps.M + (ps.C ? ' ' : '') + ps.C + "）";
                }
              }
            } catch (ex) {

            }
          }
          if (i == 3)//最多显示4个
            break;
        }
        return packString;
      },
      //查询条件的门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      //查询条件的供应商之后执行
      afterSelPcustomer(customerserial, customername, row) {
        this.pcustomer = customername
        this.pcustomerserial = customerserial
        this.bindGrid()
      },

      //客服填写订单选择门店之后模拟登录
      afterSelExternalLogin(customerserial, customername, row) {
        simulationLogin({loginName: row.linkmantel, customerserial: customerserial}).then(response => {
          if (response.data.code == 0) {
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', window.location.host);
            window.open("http://" + localStorage.getItem("domain") + "/H5/keFuindex.html");
          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })

      },
      clearCustomerName() {
        // this.isClickEvent = false
        this.customername = ""
        this.customerserial = ""
        this.bindGrid()
      },
      clearPcustomer() {
        // this.isClickEvent = false
        this.pcustomer = ""
        this.pcustomerserial = ""
        this.bindGrid()
      },
      show1: function (item) {
        item.isShow = true
      },
      hide1: function (item) {
        item.isShow = false
      },
      //使用商品树
      // checktree1(guids, names, arr) {
      //   if (guids) {
      //     if (arr[0].hasChildren) {//类别
      //       this.categorycode = guids + ";"
      //     } else {//seedcode
      //       this.seedcode = guids + ","
      //     }
      //   } else {
      //     this.categorycode = ""
      //     this.seedcode = ""
      //   }
      //   this.bindGrid()
      // },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //清空商品le
      clearCategory() {
        this.categorycode = ''
        this.categoryname = ''
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //显示商品类别选择页面
      showCategoryDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgoodscategorySel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = ";" + row.seedcode + ","
        this.seedname = row.seedname
        this.bindGrid()
      },
      //选择商品类别之后执行
      afterSelectCategoryCode(row) {
        this.categorycode = "," + row.categorycode
        this.categoryname = row.categoryname
        this.bindGrid()
      },
      //加工单、销售单、拼好货、退货单
      getOrderType(item) {
        var showColor = '#909399';
        var ordername = '';

        if (item.formtype == 42) {
          ordername = item.yewutype
          if (item.parentguid) {
            ordername = '退货单'
            showColor = '#F56C6C'
          } else if (item.filepalce) {
            ordername = '拼好货'
          } else {
            if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
              for (let i in item.jxcformdetailDOList) {
                if (item.jxcformdetailDOList[i].filltemplate == "50") {
                  ordername = '加工单'
                }
              }
            }
          }
        }
        if (ordername == '加工单')
          showColor = 'red';
        if (item.voucherdetailguid) {
          ordername = '铺货-' + ordername;
          showColor = '#67C23A';
        }
        if (showColor)
          return "<span style='color:" + showColor + ";'><b>" + ordername + "</b></span>"
        return ordername
      },
      //判断此订单的订单明细中是否存在备货的，如果有一个是备货就可以显示通知仓库
      isHaveStock(item) {
        if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          for (let i in item.jxcformdetailDOList) {//item.jxcformdetailDOList[i].filltemplate == "50" ||
            if (item.jxcformdetailDOList[i].nostock == 1) {//在其余条件的基础上，如果是加工，肯定显示
              return true
            }
          }
        }
        return false
      },
      //判断此订单的订单明细中是否存在不备货的，如果有一个是不备货且不是加工（filltemplate!=50）的就可以显示发起采购
      isHaveNoStock(item) {
        if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          for (let i in item.jxcformdetailDOList) {
            if (item.jxcformdetailDOList[i].nostock == -1 && item.jxcformdetailDOList[i].filltemplate != '50') {
              return true
            }
          }
        }
        return false
      },
      //是否加工单
      isMachine(item) {
        if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          if (item.jxcformdetailDOList[0].filltemplate == "50") {
            return true
          }
        }
        return false
      },
      //发货通知仓库的按钮的文本
      getFaHuoTongZhiCangKuText(item) {
        let text1 = "通知仓库"
        if (this.isMachine(item)) {
          text1 = "通知加工"
        }
        return text1
      },

      //查看加工单
      lookMachining(row, canOperate) {
        this.$refs.machiningedit.initData(row, canOperate)
        this.$refs.machiningedit.show()
      },
      lookPrintDetails() {
        this.printItem.status = this.printItem.jxcformdetailDOList[0].filltemplate == "50" ? '300' : '350';
        this.lookDetails(this.printItem, 'print')
      },
      lookMachiningCopy(row) {
        this.$refs.machiningeditcopy.initData(row)
        this.$refs.machiningeditcopy.show()
      },
      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      lookDetails(row, roletype) {
        if (!roletype)
          roletype = this.roletype;
        // if (row.jxcformdetailDOList != null && row.jxcformdetailDOList[0].filltemplate == "50") {
        //   this.$refs.machiningedit.initData(row)
        //   this.$refs.machiningedit.show(roletype)
        // } else {
          this.$refs.DataContactEdit.initData(row)
          this.OpenDialog()
        // }
      },
      looktuihuo(row) {
        this.$refs.tuihuo.initData(row, 1)
        this.$refs.tuihuo.show();
      },
      //退运费
      tuiYunFei(item) {
        this.itemtemp = item
        this.$refs.FreightRefund.show(item)
      },

      afertFreightRefund(expressfee) {
        this.itemtemp.expressfee = this.itemtemp.expressfee - expressfee
      },

      //修改运费按钮出发
      showUpdateExpressFee(item) {
        this.itemtemp = item
        this.$refs.UpdateExpressFee.show(item.expressfee);
      },
      //修改运费之后的回调方法
      afterUpdateExpressFee(expressfee) {
        updateExpressFee({
          unitguid: this.itemtemp.unitguid,
          expressfee: expressfee
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '操作成功!'
            });
            this.itemtemp.expressfee = expressfee
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder, "", this.roletype)
        this.$refs.BuyorderDetail.show();
      },
      getLiuYan(remark,item) {
        if (!item.jxcformdetailDOList || item.jxcformdetailDOList.length == 0) {
          return getRemark(remark, '采购留言');
        }
        return getRemark(remark);
      },
      getbuyLiuYan(remark,item) {
        if (item.seedinfo && item.seedinfo.indexOf(';') > -1 && (!item.jxcformdetailDOList || item.jxcformdetailDOList.length == 0)) {
          return item.seedinfo.split(';')[1] +" "+ getRemark(remark, null, '采购留言');//只显示采购留言
        }
        return '';
      },
      showLiuYan(item, opmsg, status) {//留言
        this.$refs.liuyan.show(item, opmsg, status)
      },
      afterLiuYan(remark, unitguid, status, erpserial) {//留言
        if (status && status != '') {//填写的是处理意见
          this.saveStatus(unitguid, status, erpserial);
        } else {
          this.tableData.forEach(item => {
            if (item.unitguid == unitguid) {
              item.remark = remark;
            }
          })
        }
      },

      handleChangeStatus(row, status, message) {
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveStatus(row.unitguid, status)
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });
      },
      saveStatus(unitguid, status, erpserial) {
        updatejiagong({unitguid: unitguid, status: status, erpserial: erpserial}).then(response => {
          this.bindGrid('1', '1');
          if (response.data.code == 0) {
            // this.$message({
            //   type: 'success',
            //   duration: 1500,
            //   message: '操作成功!'
            // });
          } else {
            this.$message({
              type: 'error',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      handlesaleCsagreementToVoid(row) {
        this.$confirm('是否确定作废?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          cstagreementUpdateData({groupguid: row.groupguid, status: row.status}).then(response => {
            this.bindGrid();
            if (response.data.code == 0) {
              this.$message({
                duration: 1500,
                type: 'success',
                message: '操作成功!'
              });
            } else {
              this.$message.error('操作失败')
            }
          })
        }).catch(() => {
          this.$message({
            duration: 1500,
            type: 'info',
            message: '已取消作废'
          });
        });


      },

      //确认步骤通知仓库或者通知加工按钮
      handleQueRenTongZhiOrMachine(item) {
        this.printItem = item;
        let biaoji = "store"
        if (this.isMachine(item)) {
          biaoji = "machining"
        }
        if (biaoji == "store") {
          //通知仓库
          item.biaoji = "store"
          // if (item.applybydserial == "" && !item.pcustomerserial) {
          //   this.$message({
          //     type: 'warning',
          //     duration: 1500,
          //     message: '请先确认供应商!'
          //   });
          //   return
          // }
          this.$refs.StoreEdit.initData(item, -1, 'medium-dialog');
        } else {//通知加工
          this.$refs.StoreEdit.initData(item, 1, 'mini-dialog')
          // this.handleChangeStatus(item, '300', '是否确定通知加工？')
        }
      },
      //退货客服岗页面驳回退货单功能
      handleCancelTuiHuoDan(item) {
        var data = []
        data.unitguid = item.unitguid
        data.erpserial = item.erpserial
        data.parenterpserial = item.parenterpserial
        this.$confirm('是否驳回退货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          cancelTuihuoOrder(data).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '驳回成功',
                type: 'success',
                duration: 1500
              })
              this.bindGrid('1', '1')
            } else {
              this.$message({
                message: '驳回失败',
                type: 'error',
                duration: 1500
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '取消删除'
          });
        });

      },
      //退货确认页面点击通知仓库按钮
      handleQueRenTongZhi(item) {
        if (this.roletype == 'supply') {
          this.$confirm('是否确定退货?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updatecangku({
              unitguid: item.unitguid,
            }).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                var handlelog = {}
                handlelog.erpserial = item.erpserial
                handlelog.isopen = 1
                handlelog.casestepname = '客服岗已确认'
                handlelog.remark = '供应商操作'
                saveData(handlelog).then(response => {
                })
                this.bindGrid(1, 1)
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error',
                  duration: 1500,
                })
              }
            })
          }).catch(() => {
          })
        } else {
          this.$refs.StoreEdit.initData(item, -1, 'mini-dialog')
        }
      },
      //点击填写订单按钮执行，选择门店，模拟H5登录
      showWriteReturnOrderWeb() {
        this.clearTimer()
        // this.$refs.tianxieOrder.show(1, '选择门店')
        this.$refs.WriteReturnOrder.show(1, '门店下单', this.roletype)
      },
      showWriteFrameReturnOrderWeb() {
        this.$refs.WriteFrameReturnOrder.show(1, '', this.roletype)
      },
      //点击填写订单按钮执行，选择门店，模拟H5登录
      showWriteOrderWeb() {
        this.clearTimer()
        // this.$refs.tianxieOrder.show(1, '选择门店')
        this.$refs.WriteOrder.show(1, '门店下单')
      },
      //镜架类下单
      showjingjiaOrderWeb() {
        this.clearTimer()
        this.$refs.WriteFrameReturnOrder.show(1, '门店下单')
      },
      //点击采购菜单的采购按钮
      showCaiGou() {
        this.$refs.BuyorderDetailEdit.show()
        this.$refs.BuyorderDetailEdit.initData()
      },
      //批量采购
      showbatchCaiGou() {
        this.$refs.BatchBuyorderDetailEdit.show()
        this.$refs.BatchBuyorderDetailEdit.initData()
      },
      showotherCaiGou(){
        this.$refs.OtherBuyorderDetailEdit.show()
        this.$refs.OtherBuyorderDetailEdit.initData()
      },
      //批量导出
      showbatchDaoChu() {
        this.$refs.BatchBuyDaoChu.show(this.roletype, this.status)
        this.$refs.BatchBuyDaoChu.init()
      },
      addMachineOrder(item) {
        this.$refs.AddMachinOrder.show(item);
      },
      //申请采购
      sbuyorder(item) {
        this.printItem = item;
        item.bn = "发起采购"
        this.$refs.BuyoderEdit1.show(item)
        this.$refs.BuyoderEdit1.initData(item)
        //this.$refs.BuyoderEdit1.initData(item.pcustomerserial,item.pcustomer)
      },
      //填写发货单
      showFaHuoDan(item, btn) {
        this.clearTimer()
        if (item.jxcformdetailDOList && item.jxcformdetailDOList[0].filltemplate == "50") {
          this.$refs.machiningedit.initData(item, 0, btn)
          this.$refs.machiningedit.show()
        } else {
          this.$refs.DataContactEdit.initData(item, btn)
          this.OpenDialog()
        }
      },
      cutItemAfterHandle(groupguid) {
        this.bindGrid();
      },
      showErCiFaHuo(item) {
        this.$refs.TwoShipmentsEdit.show(item.unitguid, item.customerserial, item.erpserial)
      },

      showZhuanDan(item) {
        this.seedcodes = []
        this.itemtemp = item
        if (item.jxcformdetailDOList) {
          for (let i = 0; i < item.jxcformdetailDOList.length; i++) {
            this.seedcodes.push(item.jxcformdetailDOList[i]["seedcode"])
          }
          this.$refs.zhuandan.initData(this.seedcodes)
          this.$refs.zhuandan.show()
        }
      },
      showChaiDan(item) {
        this.$refs.ChaiDandetail.initData(item)
        this.$refs.ChaiDandetail.show()
      },
      showHeBing(item) {
        this.$refs.Hebingdetail.initData(item)
        this.$refs.Hebingdetail.show()
      },
      afterZhuanDan(customerserial, customername, row) {
        updategongying({
          unitguid: this.itemtemp.unitguid,
          pcustomerserial: customerserial,
          pcustomer: customername
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              duration: 1500,
              type: 'success',
              message: '操作成功!'
            });
            // var handlelog = {}
            // handlelog.erpserial = this.itemtemp.erpserial
            // handlelog.isopen = 0
            // handlelog.casestepname = '转单'
            // handlelog.remark = '转单到' + customername
            // this.handlelog(handlelog);//处理日志 吴建修改，供应商不能给客户看
            this.itemtemp.pcustomerserial = customerserial
            this.itemtemp.pcustomer = customername

          } else {
            this.$message.error('操作失败')
          }
        })
      },
      //填写入库单
      writeRuKuDan(item, isbuyorder) {
        let isshowconfirm = 1
        this.$refs.BuyorderDetail.initData(item, isbuyorder, isshowconfirm)
        this.$refs.BuyorderDetail.show();
      },
      //待审核
      waitShenHe(row) {
        if (row.isdistribute == 80||row.isdistribute == 40) {
          this.$refs.BatchBuyorderPriceEdit.initData(row);
        } else {
          this.$refs.BuyUpdateCostPrice.show(row)
        }
      },
      //取消采购单
      cancelBuy(item) {
        this.$confirm('是否取消采购单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          buyoderremove({unitguid: item.unitguid}).then(response => {
            this.bindGrid();
            if (response.data.code == 0) {
              this.$message({
                duration: 1500,
                type: 'success',
                message: '操作成功!'
              });
              logremove({erpserial: item.erpserial, remark: '向供应商发起采购'}).then(response => {
              })
            } else {
              this.$message.error('操作失败')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '取消删除'
          });
        });
      },
      //确认退款按钮
      tuikuan(item) {
        this.$refs.ConfirmRefundEdit.initData(item)
      },
      getPcustomerInfo(item) {
        let result = "";
        if (item.pcustomerserial) {
          result = this.roletype == "customerservice" ? "" : "<span style='color:black;'>" + item.pcustomer + "</span>"
          if (item.buyinfo) {
            let temp = JSON.parse(item.buyinfo)
            if (temp.status == "810") {
              result += "<span style='color:black;'>采购中</span>"
            } else if (temp.status == "820") {
              result += "<span style='color:black;'>采购已完成</span>"
            }
          }
        } else {
          result = '待确认供应商'
        }
        return result
      },

      changestate(item) {
        if (this.checkedAll == true) {
          this.tableData.forEach((value, index) => {
            this.checkmodel.push(value.erpserial)
          });
        }
      },

      bindTip() {
        if (this.status == "200" || this.status == "300" || this.status == "350" || this.status == "650" || this.status == "655" || this.status == "660" || this.status == "700") {
          this.$emit("bindTip")
        }
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        if (this.roletype == 'store' || this.roletype == 'buy') {
          cusandptbyind({}).then(response => {
            this.jxcstoreData = response.data.obj
            //默认仓库
            if (this.userInfoModel.cangku) {
              let temp1 = this.userInfoModel.cangku.split(";")
              biaoji:
                for (let i in temp1) {
                  for (let j in  this.jxcstoreData) {
                    if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                      this.cangkucode = temp1[i]
                      break biaoji;
                    }
                  }
                }

            }
            if (this.cangkucode && this.roletype == 'store' && this.status == "350") {//选择了仓库
              this.invoicesource = '2';//默认待打印的订单
            }
            if (this.userInfoModel.independentserial == "") {//总部登录
              this.jxcstoreData.unshift({
                cangkuname: "全部仓库",
                cangkucode: ''
              })
            }
            this.bindGrid('1');
          })
        } else {
          this.bindGrid('1');
        }
      },
      getStatusName(item) {
        for (let i in this.statusobj) {
          if (this.statusobj[i].value == item.status) {
            return this.statusobj[i].text
          }
        }
        return ""
      },
      search() {
        this.erpserials = ''
        this.tracknum = ''
        if (this.roletype == 'buy') {
          if (this.searchdata.substring(0, 2) == '42') {
            this.hetongserial = this.searchdata
            this.trackSelect()
          } else {
            this.bindGrid()
          }
        } else {
          this.bindGrid()
        }
      },
      bindPagination() {//分页不重新取总数
        this.countPageTotal = false;
        this.bindGrid()
      },
      bindGrid(needrendertitle, needrefreshtip) {
        var scrollTop=document.getElementById('scrollArea').scrollTop;
        //根据跟踪号、供应商号搜索，不出发 发货来源条件
        var noPage = false;
        if (this.roletype == 'store' && this.status == "350" && this.cangkucode && (
          this.invoicesource.toString() == '2' || this.invoicesource.toString() == '3' || this.invoicesource.toString() == '4')) {
          noPage = true
          this.pagination.pageSize = 100;
        } else {
          if (this.roletype == 'jiesuan' && this.mystatus == '810') {
            noPage = true
            this.pagination.pageSize = 100;
          } else {
            this.pagination.pageSize = 20;
          }
        }
        if(this.shoudongcaigou.toString()=="1"){
          this.statuses="810,820";
        }

        var formData = {
          needtuihuoinfo: this.needtuihuoinfo,
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.hetongserial != '' ? '' : this.searchdata.trim(),
          status: this.statuses ? "" : this.status,
          statuses: this.statuses,
          formtype: this.formtype,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          independentserial:this.status=='all'?'all':this.independentserial,
          applybydserial:this.status=='all'&&this.independentserial!='all'?this.independentserial:'',
          customerserial: this.customerserial,
          pcustomerserial: this.pcustomerserial,
          needdetail: "1",
          isshowbuyinfo: this.isshowbuyinfo,
          isshowstore: this.isshowstore,
          isshowpayinfo: this.isshowpayinfo,
          isshowtuihuofrombuy: this.isshowtuihuofrombuy,
          neefahuoinfo: this.showFaHuoInfo ? "1" : "0",
          isreturnorder: (this.status == 'all' && this.statuses.indexOf(',') > -1) ? '' : '-999',
          fileuname: this.fileuname,
          cangkucode: (this.roletype == 'store' && (this.status != '400' || this.isZongBu())) || this.roletype == 'buy' ? this.cangkucode : "",
          datetype: this.datetype,
          startdate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[0] : "",
          enddate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[1] + " 23:59:59" : "",
          erpserials: this.erpserials,
          tracknum: this.tracknum.trim(),
          invoicesource: (this.searchdata || this.tracknum) ? '' : this.invoicesource,
          iswriteorder: this.iswriteorder,
          shoudongcaigou: this.shoudongcaigou,//  手动采购 1未审核 2审核通过
          purchase: this.purchase,// 仓库岗待收货 用
          needtotal: "-1",//不计算记录总数
        };

        this.tableData = []
        getCstagreementListDataNew(formData, this.noloading).then(response => {
          if (formData.invoicesource != ((this.searchdata || this.tracknum) ? '' : this.invoicesource)) {//不再绑定
            return;
          }
          this.tableData = response.data.obj.rows
          if (response.data.quehuonum != 'no') {
            this.cangkuquehuoNum = ' ' + (response.data.quehuonum || 0);
          }

          if (noPage) {
            this.countPageTotal = false;
            this.pagination.total = this.tableData.length;
          }

          if (this.countPageTotal) {

            formData.needtotal = "1";
            getCstagreementListDataNew(formData, true).then(response => {
              this.pagination.total = response.data.obj
            });

          } else this.countPageTotal = true;

          if (this.tableData.length == 0) {
            return
          }

          this.$nextTick(() => {
            document.getElementById('scrollArea').scrollTop=scrollTop;
          });

          let mapgongyingshang = new Map();
          let mapcustomer = new Map();
          for (let i = 0; i < this.tableData.length; i++) {
            this.$set(this.tableData[i], 'checkedGlasses', [])
            if (this.roletype == "machining") {
              if (this.tableData[i].remark != '' && this.tableData[i].remark != undefined) {
                var remark = JSON.parse(this.tableData[i].remark);
                remark.forEach(item => {
                  if (item.type == '眼镜已到') {
                    this.tableData[i].checkedGlasses = item.msg == '' || item.msg == undefined ? [] : item.msg.split(',')
                  }
                })
              }
            }
            this.$set(this.tableData[i], "isShow", false)
          }

        }).catch((error) => {
          // this.$message.error(JSON.stringify(error))
        });

        if (needrefreshtip == "1") {
          this.bindTip()
        }

      },
      OpenDialog() {
        this.clearTimer()
        this.$refs.DataContactEdit.yincangdayin()
        this.$refs.DataContactEdit.show()
      },
      //关闭从此页面打开的对话框之后执行
      afterCloseDialog() {
        this.setTimer()
      },
      //设置定时
      setTimer() {
        // this.timer= setInterval(this.bindGrid, 300000)  //定时执行，5分钟刷新一次
        if (this.status == "200" || this.status == "300")// || this.status == "650" || this.status == "655" || this.status == "660" || this.status == "700")
        {
          if (!this.timer) {
            this.timer = setInterval(this.beforeInterval, 300000)  //定时执行，5分钟刷新一次
            //this.noloading = true
          }
        }
      },
      beforeInterval() {
        if (!this.tracknum && !this.searchdata && !(this.status == "350" && this.invoicesource.toString() != '2')) {
          this.bindGrid(null, '1');
        }
      },
      //取消定时
      clearTimer() {
        if (this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
          clearInterval(this.timer) //关闭
          this.timer = null
          this.noloading = false
        }
      },
      getPackages(packages) {
        if (packages) {
          var pg = JSON.parse(packages);
          return (pg.type || '') + (pg.Y ? (pg.Y + '，') : '') + (pg.X || '')
        }
        return '';
      },
      controlRight() {
        if (this.roletype == 'store' || this.roletype == 'buy') {
          this.independentserial = "all"
        }
        switch (this.status) {
          case "100"://未支付
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "0"//是否获取支付信息
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              // this.showcancelbtn = true
            }
            break;
          case "150"://待选货
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.isshowstore = "1"//显示库存
            this.isshowpayinfo = "1"//获取支付信息
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              // this.showxuanhuobtn = true
              // this.showfahuotongzhicangkubtn = true
            }
            break;
          case "200"://待确认
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "1"//获取支付信息
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              this.showwriteorderbtn = true
              this.showfahuotongzhicangkubtn = true
              this.showfaqicaigoubtn = true
              this.showzhuandanbtn = true
              this.showPcustomerInfo = true
              this.showlookcaigouorderbtn = true
              this.isshowbuyinfo = "1"
            } else if (this.roletype == "customerservice") {
              /*************表示客服菜单进入***********////
              this.showwriteorderbtn = true
            }
            break;
          case "300"://待加工
            this.showliuyanbtn = true
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "1"//获取支付信息
            this.showlookorderbtn = true
            this.showPcustomerInfo = true
            if (this.roletype == "machining") {
              /*************表示加工菜单进入***********////
              this.showquerenjiagongbtn = true
              this.showzhuandanbtn = true
            }
            break;
          case "350"://待发货
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "0"//获取支付信息
            // this.isshowstore = "1"//显示库存
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "store") {
              /*************表示仓库菜单进入***********////
              this.isshowbuyinfo = "1"
              this.showPcustomerInfo = true
              this.showlookcaigouorderbtn = true//显示查看采购单按钮
              this.showtianxiefahuobtn = true
              this.showtuihuidingdanbtn = true
              if(isUGO()&&this.userInfoModel.independentserial){
                this.showtuihuidingdanbtn = false
              }
            } else if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              this.isshowbuyinfo = "1"
              this.showPcustomerInfo = true
              this.showlookcaigouorderbtn = true//显示查看采购单按钮
            } else if (this.roletype == "customerservice") {
              this.isshowbuyinfo = "1"
              this.showPcustomerInfo = true
            }
            break;
          case "400"://待配送
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "1"//获取支付信息
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            this.showpeisongquerenbtn = true
            if (!this.isZongBu()) {
              this.cangkucode = ""//必须加
            }
            break;
          case "500"://已发货    ==   已成交
            this.needtuihuoinfo = "1"
            this.showOrderMoneyInfo = true
            this.isshowpayinfo = "1"//获取支付信息
            this.showliuyanbtn = true
            this.showFaHuoInfo = true
            this.showlookorderbtn = true//订单
            if (this.roletype != "customerservice") {
              this.isshowbuyinfo = "1"
              this.showlookcaigouorderbtn = true//显示查看采购单按钮
            }
            if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              this.showPcustomerInfo = true
            }
            break;
          case "600"://已收货

            break;
          case "650"://退货客服岗待确认              或者供应商账户登录操作 2019-1-24
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            this.showtuihuotongzhicangkubtn = true
            if (this.roletype == "customerservice") {
              this.showupdateexpressfeebtn = true
              this.showwriteorderbtn = true
            }
            break;
          case "655"://退货订单岗待确认
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "order") {
              /*************表示订单菜单进入***********////
              this.showtuihuotongzhicaiwubtn = true
              // this.showtuihuikefubtn = true
            }
            break;
          case "660"://退货仓库岗待确认
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "store") {
              /*************表示仓库菜单进入***********////
              this.showtuihuotongzhicaiwubtn = true
              this.showtuihuikefubtn = true
              this.showwriteorderbtn = true
            } else if (this.roletype == "supply") {
              /*************表示供应商利润菜单进入***********////
              this.showtuihuotongzhicaiwubtn = true
            }
            break;
          case "700"://待退款
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            if (this.roletype == "jiesuan") { //从结算菜单进入
              this.showtuihuotuikuanbtn = true
              // this.showtuihuikefubtn = true
            }
            break;
          case "750"://退款完成
            this.showliuyanbtn = true
            this.independentserial = "all"
            this.showOrderMoneyInfo = true
            this.showlookorderbtn = true
            if (this.roletype == "order") {//从订单菜单进入
            }
            break;
          case "810"://采购待收货
            this.formtype = 32
            this.showliuyanbtn = true
            this.showlookcaigoubtn = true
            this.independentserial = 'all'//2018-10-9
            if (this.roletype == "buy") {
              /*************表示采购菜单进入***********////
              this.showZhiJianInfo = true
              this.showcancelcaigoubtn = true
              this.showcaigoubtn = true
            } else if (this.roletype == "store") {
              /*************表示仓库菜单进入***********////
              this.showzhijiandanbtn = true
              this.showFramecaigoubtn=true
              this.showrukudanbtn = true
              this.isshowtuihuofrombuy = "1"
            }
            break;
          case "820"://采购已收货
            this.formtype = 32
            this.showliuyanbtn = true
            this.showZhiJianInfo = true
            this.showCaiGouShouHuoInfo = true
            this.showlookcaigoubtn = true
            this.independentserial = 'all'//2018-10-9
            break;
          case "storeyituihuo"://仓库的已退货菜单，对应status的700、750，需要特殊处理
            this.statuses = "700,750"
            this.showOrderMoneyInfo = true
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            this.independentserial = "all"
            break;
          case "alreadymachining"://加工的已加工菜单，对应status的350、500，且fileuname不为空的数据，需要特殊处理
            this.showOrderMoneyInfo = true
            this.showPcustomerInfo = true
            this.isshowpayinfo = "1"//获取支付信息
            this.showliuyanbtn = true
            this.statuses = "350,400,500"
            this.fileuname = "notempty"
            this.showlookorderbtn = true
            this.needtuihuoinfo = "1"
            break;
          case "all"://客服的all
            this.statuses = "150,200,300,350,400,500,650,655,660,700,750"
            this.independentserial = 'all'
            this.showliuyanbtn = true
            this.showlookorderbtn = true
            this.needtuihuoinfo = "1"
            this.isshowpayinfo = "1"//获取支付信息
            this.showOrderMoneyInfo = true
            if (this.roletype != "customerservice") {
              this.isshowbuyinfo = "1"
              this.showlookcaigouorderbtn = true//显示查看采购单按钮
            } else {
              this.showwriteorderbtn = true//可填写订单
            }
            break;
        }

        //待下单功能
        if (this.showwriteorderbtn) {
          checkModuleRight({name: 'usewriteorder'}).then(reponse => {
            this.showwriteorderbtn = reponse.data.code == 0;
          });
        }
        //从订单直接发起采购
        if (this.showfaqicaigoubtn) {
          checkModuleRight({name: 'supportlinkage'}).then(reponse => {
            this.showfaqicaigoubtn = reponse.data.code == 0;
          });
        }
      },
      //是否显示价格
      diaplayprice() {
        // if (this.userInfoModel.myright.indexOf('财务') != -1 || this.userInfoModel.myright.indexOf('查看订单价格') != -1) {
        this.showlookprice = true;
        // } else {
        //   this.showlookprice = false;
        //
        // }
      },
    },
    mounted() {
      this.setTimer()//定时执行，1分钟刷新一次
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = "all";//this.userInfoModel.independentserial;

      var end = new Date();//当天
      var year=end.getFullYear();
      var month=end.getMonth()+1;
      this.searchdatevalue = [(month>6?(year + '-' + (month-6) ):((year - 1) + '-' + (6+month)))+ '-' + end.getDate(),
        year + '-' +month + '-' + end.getDate()];

      //控制权限
      this.controlRight()

      //绑定仓库,绑定列表数据
      this.cusandptbyind()
      //仓库岗  客户需要打印价格的  一直显示价格；否则根据权限查看订单价格   财务
      //其它 根据 权限查看订单价格   财务
      this.diaplayprice()
      independentDept().then(response => {
        this.idd = response.data.obj
        if (this.userInfoModel.independentserial != "" && (this.roletype == "order" || this.roletype == 'customerservice')) {
          //此时是经销商账户登录，且是订单或者客服菜单进入，  需要在服务部门下拉框增加  总部 选项
          this.idd.unshift({serialnum: "", dname: this.userInfoModel.tenantname})
        }
        this.idd.unshift({serialnum: "all", dname: "全部"})
      })
    },
    beforeDestroy() {
      this.clearTimer()
    },
    watch: {
      checkmodel: {
        handler() {
          if (this.checkmodel.length == this.tableData.length) {
            this.checkedAll = true
          } else {
            this.checkedAll = false
          }
        },
      },
    },
    components: {
      AutoComplete,
      BuyOrderEditSeedDetail,
      CstagreementEdit,
      BuyorderEdit,
      ExternaldeptChaiDanSel,
      StoreDetailListSupplySee,
      BuyorderDetail,
      LiuYanEdit,
      CstagreementEditChaiDan,
      BuyorderDetailEdit,
      CstagreementEditHeBing,
      CstagreementMachiningEdit,
      BatchBuyorderPriceEdit,
      StoreEdit,
      UpdateExpressFee,
      ConfirmRefundEdit,
      TwoShipmentsEdit,
      JxcgooddetailSel,
      JxcgoodscategorySel,
      FreightRefund,
      InvoiceList,
      WriteOrder,
      WriteReturnOrder,
      BatchBuyorderDetailEdit,
      OtherBuyorderDetailEdit,
      WriteFrameReturnOrder,
      BuyUpdateCostPrice,
      BatchBuyDaoChu,
      RapidMachining,
      AddMachinOrder
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @import '../../../../static/css/clear.css';
  @import '../../../../static/css/index.css';

  .orderTable {
    overflow: auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementList.vue